import React from "react";
import WidgetWrapper from "components/WidgetWrapper";
import FlexBetween from "components/FlexBetween";
import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import MoreTimeOutlinedIcon from "@mui/icons-material/MoreTimeOutlined";

import Header from "components/Header";
import { useLevelAdmin } from "./hooks/useLevelAdmin";
import LevelForm from "./components/levelForm";
import LevelGrid from "./components/levelGrid";

function LevelAdmin() {
  const {
    isLargeScreen,
    open,
    editMode,
    currentLevel,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
    showOrg,
  } = useLevelAdmin();

  return (
    <Box m={isLargeScreen ? "1rem" : "1.5rem 0.5rem 2rem 0.5rem"}>
      <WidgetWrapper>
        <FlexBetween>
          <Header
            title="ALT Coach Year Admin"
            subtitle="Administer your Year details"
          />
          {showOrg && (
            <Button
              variant="contained"
              color="primary"
              sx={{
                borderRadius: "5px",
                fontSize: "12px",
                padding: "5px 10px",
              }}
              onClick={handleOpen}
            >
              <MoreTimeOutlinedIcon sx={{ mr: "0.5rem" }} />
              Add new Year
            </Button>
          )}
        </FlexBetween>

        <LevelGrid handleEditOpen={handleEditOpen} />

        {/* The Dialog component is a modal dialog that is displayed over the current page. */}
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogTitle>
            {editMode
              ? `Edit Year - ${currentLevel.name}`
              : "Add a New Year to your School"}
          </DialogTitle>
          <DialogContent>
            <LevelForm
              editMode={editMode}
              currentLevel={currentLevel}
              setOpen={setOpen}
              handleClose={handleClose}
            />
          </DialogContent>
        </Dialog>
      </WidgetWrapper>
    </Box>
  );
}

export default LevelAdmin;
